import { render, staticRenderFns } from "./TeacherReviewList.vue?vue&type=template&id=25a16586&scoped=true&"
import script from "./TeacherReviewList.vue?vue&type=script&lang=js&"
export * from "./TeacherReviewList.vue?vue&type=script&lang=js&"
import style0 from "./TeacherReviewList.vue?vue&type=style&index=0&id=25a16586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a16586",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
